import { MoreDots, UserProfileAdd } from 'blaze-ui/icons'
import { useModals } from 'almanac-ui/Modal'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useAuth } from 'hooks/UseAuth'
import { ShareSheet } from 'components/ShareSheet/ShareSheet'
import { AlmanacFile } from 'types'
import { Text } from 'blaze-ui/Text/Text'
import { ProjectMenuDrawer } from 'blaze-components/ProjectMenu/ProjectMenuDrawer'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { SwitchViewButton } from 'screens/Finder/components/Header/SwitchViewButton'
import { useCallback } from 'react'
import { createPortal } from 'react-dom'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { TopBarButton } from 'blaze-components/WriterTopBar/TopBarButton'

export const FinderMobileTopBar = observer(({ folder }: { folder: AlmanacFile }) => {
  const theme = useHeaderTheme()
  const { openModal } = useModals()
  const auth = useAuth()
  const workspace = useCurrentWorkspace()
  const inFolderAsMember = auth && !workspace?.guest
  const isUploadsFolder = folder.uploads_project
  const { drawersStore } = useRootStore()

  const handlePress = () => {
    openModal(ShareSheet, {
      file: {
        id: folder.id,
        type: 'folder',
      },
    })
  }

  return (
    <MobileTopBarContainer.Root data-theme={theme}>
      <MobileTopBarContainer.Left>
        <MobileTopBarContainer.BackButton />
      </MobileTopBarContainer.Left>
      <MobileTopBarContainer.Center>
        <Text lineClamp={1}>{folder.title}</Text>
      </MobileTopBarContainer.Center>
      <MobileTopBarContainer.Right>
        {!isUploadsFolder && (
          <TopBarButton
            icon={MoreDots}
            onPress={() => drawersStore.openDrawer(ProjectMenuDrawer, { folderId: folder.id })}
            label="Project Menu"
          />
        )}

        <div id={MOBILE_FINDER_VIEW_SWITCHER} />
        {inFolderAsMember && !isUploadsFolder && <TopBarButton onPress={handlePress} icon={UserProfileAdd} />}
      </MobileTopBarContainer.Right>
    </MobileTopBarContainer.Root>
  )
})

export const MOBILE_FINDER_VIEW_SWITCHER = 'mobile-finder-view-switcher'

export const MobileFinderViewSwitcher = ({ folder }: { folder: AlmanacFile }) => {
  const portalContainer = document.getElementById(MOBILE_FINDER_VIEW_SWITCHER)
  const viewSwitcher = useCallback(
    () => portalContainer && createPortal(<SwitchViewButton folder={folder} />, portalContainer),
    [folder, portalContainer],
  )

  return <>{viewSwitcher()}</>
}
